export default from './Settings';



// WEBPACK FOOTER //
// ./src/containers/Settings/index.js